/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appReadOnlyWithoutPermission]',
  standalone: false
})
export class ReadOnlyWithoutPermissionDirective implements OnInit, OnDestroy {

  @Input('appReadOnlyWithoutPermission') requiredPermission!: string;

  private destroyed$ = new Subject<void>();

  constructor(
    private controlContainer: ControlContainer,
    private permissionsService: NgxPermissionsService
  ) {
  }

  ngOnInit(): void {
    this.permissionsService.permissions$.pipe(
      // Leere Menge heisst: Rollen noch nicht geladen.
      filter(permissions => Object.keys(permissions).length > 0),
      filter(permissions => !permissions[this.requiredPermission]),
      takeUntil(this.destroyed$)
    ).subscribe(() => this.controlContainer.control?.disable());
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
